var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cs-products" },
    [
      _c("div", { staticClass: "title-box" }, [
        _vm._v(_vm._s(_vm.$t("components.sales.Cashier.products-title"))),
      ]),
      _c(
        "div",
        { staticClass: "search-box" },
        [
          _c("app-product-sku-autocomplete", {
            attrs: { label: _vm.$t("components.sales.Cashier.search-product") },
            on: {
              input: function ($event) {
                return _vm.onInput($event)
              },
            },
          }),
          _vm.isSupportSession
            ? _c(
                "button",
                {
                  staticClass: "scan-emulation",
                  attrs: { title: _vm.$ct("scan-emulation") },
                  on: {
                    click: function ($event) {
                      return _vm.showScanModal()
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "barcode" } })],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        { style: { height: "calc(100vh - 122px )" }, attrs: { tag: "div" } },
        [
          _c("app-product-list", {
            attrs: { state: _vm.state, buttons: _vm.buttons },
            on: {
              add: function ($event) {
                return _vm.add()
              },
              edit: function ($event) {
                return _vm.onEdit($event)
              },
              "add-product": function ($event) {
                return _vm.addProduct($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.openEditModal,
            callback: function ($$v) {
              _vm.openEditModal = $$v
            },
            expression: "openEditModal",
          },
        },
        [
          _c("app-cashier-button-edit", {
            attrs: { value: _vm.editButton },
            on: {
              save: function ($event) {
                return _vm.saveButton($event)
              },
              cancel: function ($event) {
                ;(_vm.openEditModal = false), (_vm.editIndex = 0)
              },
              delete: function ($event) {
                return _vm.deleteButton()
              },
            },
          }),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.openSizeModal,
            callback: function ($$v) {
              _vm.openSizeModal = $$v
            },
            expression: "openSizeModal",
          },
        },
        [
          _vm.sizeProduct && _vm.sizeTable
            ? _c("app-cashier-size-select", {
                attrs: {
                  product: _vm.sizeProduct,
                  "size-table": _vm.sizeTable,
                },
                on: {
                  select: function ($event) {
                    return _vm.selectSize($event)
                  },
                  close: function ($event) {
                    _vm.openSizeModal = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.openScanModal,
            callback: function ($$v) {
              _vm.openScanModal = $$v
            },
            expression: "openScanModal",
          },
        },
        [
          _c(
            "w-card",
            { style: { display: "block" }, attrs: { "max-width": "400" } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("scan-emulation")))]),
              _c(
                "w-card-content",
                [
                  _c("w-input", {
                    ref: "scanInput",
                    attrs: { fancy: "", label: _vm.$ct("barcode") },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.emulateScan()
                      },
                    },
                    model: {
                      value: _vm.scanCode,
                      callback: function ($$v) {
                        _vm.scanCode = $$v
                      },
                      expression: "scanCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      staticClass: "cancel",
                      on: {
                        click: function ($event) {
                          _vm.openScanModal = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: !_vm.scanCode },
                      on: {
                        click: function ($event) {
                          return _vm.emulateScan()
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$ct("scan")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }